// IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): кнопки команд в шапке виджета, не помещающиеся по ширине, прячутся (с конца ряда) — заголовку виджета
// остаётся место (читаемый минимум TITLE_READ из utils/stopClear.js, не весь заголовок). Спрятанные кнопки остаются доступны в форме-меню виджета (≡, папка
// «Command panel»: store.actionMenu_from_commandPanel берёт ВСЕ команды панели, а не только видимые).
//
// Раньше панель кнопок неактивного (и узкого, ≤ 500 px) виджета вынималась из потока (position: absolute; right: 30px; visibility: hidden → видна по наведению)
// и ложилась ПОВЕРХ заголовка. Теперь панель — в потоке у всех (у неактивного прозрачна до наведения, как и раньше по opacity), поле заголовка уступает ровно
// столько, сколько занимают поместившиеся кнопки, а лишние кнопки скрыты (v-show на обёртке .hdr-cmd), без перекрытия заголовка.
//
// Правило — по фактическим ширинам: доступно кнопкам = ширина шапки − её отступы − элементы шапки в потоке (бейдж сегмента, Stop, меню ≡, …) − место
// заголовка; кнопки берутся с начала ряда, пока помещаются; ширины скрытых кнопок — из кэша (замер, пока они были видны). Пересчёт от размера шапки
// (ResizeObserver), смены состава панели и перерисовки шапки; от того, что видно, результат не зависит — без качелей.
//
// Выключатель (реестр feSettings, по умолчанию ВКЛ): window.feSettings.set('fe.ux.widgetHeaderOverflow', false) или ?fe.ux.widgetHeaderOverflow=false —
// прежнее поведение (панель узкого виджета поверх заголовка по наведению, все кнопки в ряду). Счётчики — window._widgetHeaderOverflow.stats.

import { TITLE_MIN, TITLE_READ, stopClear_readMin } from './stopClear.js'

export const FLAG = 'fe.ux.widgetHeaderOverflow'

export function widgetHeaderOverflow_on(store) {
    try { return store?.setting?.(FLAG, true) !== false } catch (e) { return true }
}

// место заголовка, px: читаемый минимум (stopClear_readMin; 0 в настройке — прежний предел TITLE_MIN), не шире самого текста (+ отступы поля)
export function widgetHeaderOverflow_titleRoom(store, textWidth = 0, pad = 0) {
    let read = TITLE_READ
    try { read = stopClear_readMin(store) } catch (e) { read = TITLE_READ }
    if (!(read > 0)) return TITLE_MIN
    return textWidth > 0 ? Math.min(read, Math.ceil(textWidth) + 2 + pad) : read
}

// сколько кнопок с начала ряда помещается: widths — полные ширины (с полями) в порядке ряда, available — место под ряд, px; separators — индексы
// разделителей: ряд не кончается разделителем. Infinity — все помещаются.
export function widgetHeaderOverflow_count(widths, available, separators = []) {
    let total = 0, n = widths.length
    for (let i = 0; i < widths.length; i++) {
        total += widths[i]
        if (total > available) { n = i; break }
    }
    if (n >= widths.length) return Infinity
    while (n > 0 && separators.includes(n - 1)) n--
    return n
}

export const stats = { measures: 0, changes: 0, hidden: 0 }
if (typeof window !== 'undefined') window._widgetHeaderOverflow = { FLAG, stats }
